import styled from "styled-components/macro";

// shadcn's base-nova Empty (pnpm exec shadcn view empty), in styled-components.
// Departure: EmptyTitle leaves out shadcn's cn-font-heading, as the probate theme has no heading font.

const Empty = styled.div.attrs({ "data-slot": "empty" })`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--juno-space-4);
  padding: var(--juno-space-6);
  border: 0 dashed var(--border);
  border-radius: var(--radius-xl);
  text-align: center;
  text-wrap: balance;
`;

const EmptyHeader = styled.div.attrs({ "data-slot": "empty-header" })`
  display: flex;
  /* shadcn's max-w-sm */
  max-width: 24rem;
  flex-direction: column;
  align-items: center;
  gap: var(--juno-space-2);
`;

const EmptyMedia = styled.div.attrs(({ variant = "default" }) => ({
  "data-slot": "empty-icon",
  "data-variant": variant,
}))`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--juno-space-2);

  svg {
    flex-shrink: 0;
    pointer-events: none;
  }

  &[data-variant="default"] {
    background-color: transparent;
  }

  &[data-variant="icon"] {
    width: var(--juno-space-8);
    height: var(--juno-space-8);
    border-radius: var(--radius-lg);
    background-color: var(--muted);
    color: var(--foreground);
  }

  &[data-variant="icon"] svg:not([class*="size-"]) {
    width: var(--juno-space-4);
    height: var(--juno-space-4);
  }
`;

const EmptyTitle = styled.div.attrs({ "data-slot": "empty-title" })`
  font-size: var(--text-sm);
  line-height: var(--text-sm--line-height);
  font-weight: var(--juno-font-weight-regular);
  letter-spacing: -0.025em;
`;

const EmptyDescription = styled.div.attrs({ "data-slot": "empty-description" })`
  font-size: var(--text-sm);
  line-height: 1.625;
  color: var(--muted-foreground);

  /* && outranks GlobalStyle's link colours and hover underline */
  && > a:link,
  && > a:visited {
    color: inherit;
    text-decoration: underline;
    /* shadcn's underline-offset-4 */
    text-underline-offset: 4px;
  }

  && > a:hover {
    border-bottom: 0;
    color: var(--primary);
  }
`;

const EmptyContent = styled.div.attrs({ "data-slot": "empty-content" })`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  /* shadcn's max-w-sm */
  max-width: 24rem;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  /* shadcn's gap-2.5, which has no --juno-space step */
  gap: calc(var(--juno-space-1) * 2.5);
  font-size: var(--text-sm);
  line-height: var(--text-sm--line-height);
  text-wrap: balance;
`;

export { Empty, EmptyHeader, EmptyTitle, EmptyDescription, EmptyContent, EmptyMedia };
